// Playtomic white-label booking — all court/tournament/booking functions live on Playtomic.
export const PLAYTOMIC_TENANT_ID = "675e2750-9beb-4909-bd16-9c6233522a34";
export const PLAYTOMIC_URL = `https://playtomic.io/wl/${PLAYTOMIC_TENANT_ID}`;

export const openBooking = () =>
  window.open(PLAYTOMIC_URL, "_blank", "noopener,noreferrer");
